import { render, staticRenderFns } from "./MaterialName.vue?vue&type=template&id=201d14b4&"
import script from "./MaterialName.vue?vue&type=script&lang=js&"
export * from "./MaterialName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports